import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reports: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.reports',
		defaultMessage: 'Reports',
		description: 'Navigation item which links to reports view',
	},
	workload: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.workload',
		defaultMessage: 'Workload',
		description: 'Leads to page showing workload reports',
	},
	slaGoals: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.sla-goals',
		defaultMessage: 'SLA goals',
		description: 'Leads to page showing SLA goals reports',
	},
	satisfaction: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.satisfaction',
		defaultMessage: 'Satisfaction',
		description: 'Leads to page showing Satisfaction reports',
	},
	team: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.team',
		defaultMessage: 'Team',
		description: 'Header for team reports section',
	},
	defaultReports: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.default-reports',
		defaultMessage: 'Default',
		description: 'Header for default reports section',
	},
	requestsDeflected: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.requests-deflected',
		defaultMessage: 'Requests deflected',
		description: 'Leads to page showing requests deflected report',
	},
	requestsResolved: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.requests-resolved',
		defaultMessage: 'Requests resolved',
		description: 'Leads to page showing requests resolved report',
	},
	knowledgeBase: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.knowledge-base',
		defaultMessage: 'Knowledge base',
		description: 'Header for knowledge base section',
	},
	newReport: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.new-report',
		defaultMessage: 'New report',
		description: 'Option to create a new report',
	},
	manageReports: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.manage-reports',
		defaultMessage: 'Manage Reports',
		description: 'Leads to page to manage all existing reports',
	},
	custom: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.custom',
		defaultMessage: 'Custom',
		description: 'Header for custom reports section',
	},
	addons: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.addons',
		defaultMessage: 'Add-ons',
		description: 'Header for add-ons section',
	},
	itemAtlassianAnalytics: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.item-atlassian-analytics',
		defaultMessage: 'Atlassian Analytics',
		description: 'Navigation item which links to atlassian analytics view',
	},
	newLozenge: {
		id: 'spa-apps-sidebar-servicedesk.common.reports.new-lozenge',
		defaultMessage: 'New',
		description:
			'Small lozenge that appears to the right of the nav item, indicating a new feature.',
	},
});
